import styled from 'styled-components';
import { ITheme } from '../../../../styles/theme';
import DownTrend from '@/assets/icons/downTrendArrowIcon.svg?react';
import UpTrend from '@/assets/icons/upTrendArrowIcon.svg?react';

interface ContainerProps {
  theme: ITheme;
  isNegative: boolean;
  hasBorder: boolean;
}

export const Wrapper = styled.div`
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const Container = styled.div<ContainerProps>`
  min-width: 2.75rem;
  width: fit-content;
  font-weight: bold;
  font-size: 14px;
  line-height: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  ${({ theme, isNegative, hasBorder }) => `
    background: ${isNegative ? theme.colors.accent.red[10] : theme.colors.accent.green[10]};
    color: ${isNegative ? theme.colors.accent.red[100] : theme.colors.accent.green[100]};
    border-radius: ${theme.layout.spacing.nano};
    padding: ${theme.layout.spacing.nano};
    border: ${hasBorder ? '1px' : '0px'} solid ${
  isNegative ? theme.colors.accent.red[100] : theme.colors.accent.green[100]
}; 
  `}
`;

interface ITrendIcon {
  theme: ITheme;
  color: string;
}

export const UpTrendIcon = styled(UpTrend)<ITrendIcon>`
  path {
    ${({ color }: ITrendIcon) => `
      fill: ${color};
    `}
  }
`;

export const DownTrendIcon = styled(DownTrend)<ITrendIcon>`
  path {
    ${({ color }: ITrendIcon) => `
      fill: ${color};
    `}
  }
`;
